import { isDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { type AccumulatorAmountMode, accumulatorAmountModes } from '@/store/targetAccumulator/state.ts';

const AmountMode = () => {
  const amountMode = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.amountMode ?? 'Fixing',
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleAmountMode = (event: React.ChangeEvent<HTMLSelectElement>) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Amount mode changed',
      isDefined(event.target.value) ? event.target.value : 'cleared',
    );

    return checkTargetAccumulatorWithTradeCapture({
      amountMode: event.target.value as AccumulatorAmountMode,
    });
  };

  return (
    <TargetAccumulatorFormField
      formattedMessageId="targetAccumulator.form.amountMode"
      extra={
        <Tooltip
          position="right"
          contents={<FormattedMessage id={`targetAccumulator.form.amountMode.info.${amountMode}`} />}
        >
          <div className="badge badge-dismissible">
            <em className="icon icon-sm cursor-default line-height-1 text-secondary">info_outline</em>
          </div>
        </Tooltip>
      }
    >
      <Form.Select value={amountMode} onChange={handleAmountMode} size="sm" data-e2e="amount-mode-selector">
        {accumulatorAmountModes.map((mode) => (
          <option key={mode} value={mode}>
            <FormattedMessage id={`targetAccumulator.form.amountMode.${mode}`} />
          </option>
        ))}
      </Form.Select>
    </TargetAccumulatorFormField>
  );
};

export default AmountMode;
